import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import { ContentCardCommonProps } from '../../../components/ContentCard/types/propsTypes';
import { ArticleCardProps } from '../../../components/ArticleCard/ArticleCard';

const transformContentCardCommonData = (data: CMSTransformerDataType): ContentCardCommonProps => {
  let transformedContentDetail = {};
  if (data) {
    transformedContentDetail = {
      imageList: data?.image?.images?.map((banner: CMSTransformerDataType) => ({
        url: banner.image.url,
        altText: banner.alt_text,
        viewport: banner.viewport,
      })),
      tag: data?.tag,
      title: data?.display_title,
      description: data?.description,
      backgroundColor: data?.background_color?.color,
      color: data?.text_color?.color,
      themeColor: data?.theme_color?.color?.color,
      themeShade: data?.theme_color?.theme?.theme,
      url: data?.link?.url,
      target: data?.link?.target,
    };
  }
  return {
    ...transformedContentDetail,
  };
};

const transformArticleCard = (data: CMSTransformerDataType): ArticleCardProps => {
  const transformedContentCommonDetail = transformContentCardCommonData(data);
  let transformedContentDetail = {};
  if (data) {
    transformedContentDetail = {
      subTitle: data?.sub_title,
    };
  }
  return {
    componentType: ComponentType.article_card,
    ...transformedContentCommonDetail,
    ...transformedContentDetail,
  };
};

export default transformArticleCard;

export { transformContentCardCommonData };
